import { useReactiveVar } from '@apollo/client';
import { subscriptionsVar } from '@/graphql/state';

export const useSchools = () => {
  const subscriptions = useReactiveVar(subscriptionsVar);

  const schools = subscriptions.filter(sub => sub.type === 'school');

  const hasMultipleChildren = schools.length > 1;

  const subscriptionsIds = subscriptions.map(s => Number(s.id));
  const schoolsIds = schools.map(s => Number(s.id));
  
  return {
    subscriptions,
    schools,
    schoolsIds,
    hasMultipleChildren,
    mySchoolId: 'all',
    subscriptionsIds,
  };
};
